import { Button, ButtonColorVariant, ButtonVariant } from "@/components/ui/button";
import { useTranslation } from "react-i18next";
import { BaseFilterProps, Filter, FilterData } from "../_types";

export class OrderedByMeFilter extends Filter<unknown, never> {
  readonly id: string = "orderedBy";
  readonly labelSingular = "fit:OrderedByMe";
  readonly labelPlural = "fit:OrderedByMe";
  readonly placeholder = "fit:OrderedByMe";
  readonly searchPlaceholder = "fit:OrderedByMe";
  readonly emptyText = "fit:OrderedByMe";

  constructor(
    readonly userUuid: string,
    { id }: { id?: string } = {},
  ) {
    super();
    if (id) this.id = id;
  }

  getData(): FilterData {
    return {
      options: [{ id: this.userUuid, name: "fit:OrderedByMe" }],
      isLoading: false,
      error: null,
    };
  }

  render(props: BaseFilterProps) {
    return <OrderedByMeFilterComponent filter={this} {...props} />;
  }
}

function OrderedByMeFilterComponent({
  filter,
  selectedValues,
  onSelectionChange,
  disabled,
}: { filter: OrderedByMeFilter } & BaseFilterProps) {
  const { t } = useTranslation(["fit"]);
  const isActive = selectedValues.includes(filter.userUuid);

  return (
    <Button
      type="button"
      variant={isActive ? ButtonVariant.Filled : ButtonVariant.Outlined}
      colorVariant={isActive ? ButtonColorVariant.Primary : ButtonColorVariant.Secondary}
      className="w-full"
      onClick={() => onSelectionChange(isActive ? [] : [filter.userUuid])}
      disabled={disabled}
      aria-pressed={isActive}
    >
      {t("fit:OrderedByMe")}
    </Button>
  );
}
